<template>
    <div class="ma-auto pa-3" style="min-width: 600px">
        <v-img height="36" contain position="left center" src="/static/logo_u.svg"></v-img>
        <h2>Invitation</h2>
        <v-alert v-if="error" color="red" icon="mdi-alert-octagon-outline" outlined text>
            We were unable to process your invitation link. Please ask the sender to resend invitation and try again.
        </v-alert>
        <v-alert v-else color="blue" icon="mdi-alert-octagon-outline" outlined text>
            Processing invitation...
            <v-progress-circular indeterminate size="16" color="green"></v-progress-circular>
        </v-alert>
    </div>
</template>

<script>
export default {
    data() {
        return {
            error: false,
        };
    },
    mounted() {
        this.$api.checkToken(() => {
            const token = this.$route.query.t;
            const info = this.$api.jwtDecode(token);
            const next = {name: 'workspace', params: {workspaceId: info.wi}};
            this.$api.acceptInvitation(token, (_, meta) => {
                if (meta.code === 200) {
                    this.$router.push(next);
                    return;
                }
                if (meta.code === 401) {
                    const to = meta.error === 'login' ? 'login' : 'signup';
                    this.$router.push({name: to, query: {invite: token, next: this.$router.resolve(next).route.path}});
                    return;
                }
                this.error = true;
            });
        });
    },
};
</script>

<style scoped>

</style>
